var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPassErrorGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0C10.866 0 14 3.13401 14 7Z",
    fill: "#6A6A6A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.82877 3.82877C4.03379 3.62374 4.36621 3.62374 4.57123 3.82877L7 6.25754L9.42877 3.82877C9.63379 3.62374 9.96621 3.62374 10.1712 3.82877C10.3763 4.03379 10.3763 4.36621 10.1712 4.57123L7.74246 7L10.1712 9.42877C10.3763 9.63379 10.3763 9.96621 10.1712 10.1712C9.96621 10.3763 9.63379 10.3763 9.42877 10.1712L7 7.74246L4.57123 10.1712C4.36621 10.3763 4.03379 10.3763 3.82877 10.1712C3.62374 9.96621 3.62374 9.63379 3.82877 9.42877L6.25754 7L3.82877 4.57123C3.62374 4.36621 3.62374 4.03379 3.82877 3.82877Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassErrorGrey);
export default __webpack_public_path__ + "static/media/icon-pass-error-grey.629b96d9302c4322082948d015f43a27.svg";
export { ForwardRef as ReactComponent };